export const MOBILE_WIDTH_POINT = 980;
